// src/config.js

const dev = false;

export const API_BASE = dev
  ? "http://127.0.0.1:5000/api"
  : "https://qodes.se/backend/api";

// Add this for image URL handling
export const UPLOADS_BASE = dev
  ? "http://127.0.0.1:5000/uploads"
  : "https://qodes.se/backend/uploads";
